import { TrackingUtil } from './tracking-util';

/**
 * Modulo da  utilizazre per tracking da electron e da ui
 */
export module Tracking {

    export const start = (optionalParams?) => {
        return TrackingUtil.start(null,optionalParams)
    }
    
    export const end = (trackingContext,optionalParams?) => {
        TrackingUtil.end(null,trackingContext,optionalParams)
    };

    export const endWithError = (trackingContext,error,optionalParams?) => {
        TrackingUtil.endWithError(null,trackingContext, error, optionalParams)
    };


    export const info = (detail,optionalParams?) => {
        TrackingUtil.info(null,detail,optionalParams)
    }

    export const debug = (detail,optionalParams?) => {
        TrackingUtil.debug(null,detail,optionalParams)
    }

    export const error = (detail,optionalParams?) => {
        TrackingUtil.error(null,detail,optionalParams)
    }
}
